import React from 'react';
import ServiceBlock from '../../components/ConsultancyElements/ServiceBlock';
import ServiceBlock02 from '../../components/ConsultancyElements/ServiceBlock02';

const ServiceContainer = () => {
    const ServiceData = [
        {
            id: '1',
            img: 'images/services/icons/7-1.png',
            bg: 'images/services/bg-hover-1.png',
            title: 'Admission & Enrollment',
            description: 'Fill seats faster with paperless, parent-friendly admissions and real-time enrollment analytics.',
            URL:'/admission-enrollment'
        },
        {
            id: '2',
            img: 'images/services/icons/8-1.png',
            bg: 'images/services/bg-hover-2.png',
            title: 'Student Information System (SIS)',
            description: 'A single source of truth for every learner—attendance, grades, behavior, fees, and compliance.',
            URL:'/student-information-system'
        },
        {
            id: '3',
            img: 'images/services/icons/10-1.png',
            bg: 'images/services/bg-hover-4.png',
            title: 'Academic Management',
            description: 'Plan, teach, assess, and remediate in one place, aligned to national and international standards.',
            URL:'/academic-management'
        },
        {
            id: '4',
            img: 'images/services/icons/11-1.png',
            bg: 'images/services/bg-hover-5.png',
            title: 'Administrative Console',
            description: 'Run operations with school-wide visibility, centralized controls, real-time insights, streamlined workflows, and accountability.',
            URL:'/administrative-console'
        },
        {
            id: '5',
            img: 'images/services/icons/8-1.png',
            bg: 'images/services/bg-hover-1.png',
            title: 'Dynamic Website for Schools',
            description: 'Modern, mobile-first websites that integrate directly with admissions, SIS, notices, and events....',
            URL:'/dynamic-website-for-schoolst'
        },
        {
            id: '6',
            img: 'images/services/icons/7-1.png',
            bg: 'images/services/bg-hover-2.png',
            title: 'Parent Management System (PMS)',
            description: 'Bridge school and home with real-time grade tracking, fee payments, and direct parent-teacher communications.',
            URL:'/parent-management-system'
        },
        {
            id: '7',
            img: 'images/services/icons/10-1.png',
            bg: 'images/services/bg-hover-4.png',
            title: 'Human Resource Management System (HRMS)',
            description: 'Automate staff payroll, biometric attendance, faculty appraisals, and recruitment workflows built for schools.',
            URL:'/hrms'
        },
        {
            id: '8',
            img: 'images/services/icons/11-1.png',
            bg: 'images/services/bg-hover-5.png',
            title: 'Learning Management System (LMS)',
            description: 'Interactive digital learning, virtual classrooms, automated quizzes, and self-paced course content.',
            URL:'/learning-management-system'
        },

    ];

    return (
        <div className="inner-column">
            <div className="row clearfix">

                {
                    ServiceData.map(data => <ServiceBlock
                        key={data.id}
                        data={data}
                    />)
                }


                <ServiceBlock02
                    bg='images/services/bg-2.png'
                    title='International Curriculum Development' />


            </div>
        </div>
    );
};

export default ServiceContainer;